import { useState, useEffect } from "react";
import SectionCard from "../../Components/SectionCard";
import TextboxSet from "../../Components/TextboxSet";
import DropdownSet from "../../Components/DropdownSet";
import { XMarkIcon } from "@heroicons/react/24/solid";
import ImageUpload from "../../Components/ImageUpload";

const Customizations = ({
  templateCustomizations,
  setTemplateCustomizations,
}) => {
  const handleImageChange = (value) => {
    setTemplateCustomizations({
      ...templateCustomizations,
      image: value,
    });
  };

  const handleRemoveImage = () => {
    setTemplateCustomizations({
      ...templateCustomizations,
      image: "",
    });
  };

  return (
    <div>
      <SectionCard title="Customizations">
        <div className="flex flex-col w-full gap-6">
          <div className="flex w-full items-center gap-6">
            <DropdownSet
              name="title_font"
              label="Title Font"
              value={templateCustomizations.title_font}
              options={["Arial", "Helvetica", "Times New Roman"]} // Example options
            />
            <DropdownSet
              name="content_font"
              label="Content Font"
              value={templateCustomizations.content_font}
              options={["Arial", "Helvetica", "Times New Roman"]} // Example options
            />
          </div>
          <TextboxSet
            name="theme_color"
            label="Theme Color"
            type="color"
            className="p-0 h-[40px] w-[80px]"
            onChange={(event) => {
              setTemplateCustomizations({
                ...templateCustomizations,
                theme_color: event.target.value,
              });
            }}
            value={templateCustomizations.theme_color}
          />
          <div className="flex flex-col w-full">
            <ImageUpload handleChange={handleImageChange} />
            {templateCustomizations.image && (
              <div className="relative flex flex-col w-full max-h-[200px] bg-black rounded-xl justify-center items-center">
                <div className="absolute left-[20px] top-[8px] flex items-center gap-[18px]">
                  <XMarkIcon
                    className="size-[16px] h-fit text-white hover:cursor-pointer"
                    onClick={() => handleRemoveImage()}
                  />
                  <p className="h-fit text-white font-normal">
                    {templateCustomizations.image.split("/").pop()}
                  </p>
                </div>
                <img
                  src={templateCustomizations.image}
                  alt="event-image"
                  className="h-[200px] object-contain"
                />
              </div>
            )}
          </div>
        </div>
      </SectionCard>
    </div>
  );
};

export default Customizations;
